import { lazy } from 'react';

export const HomePage = lazy(() => import('pages/Home/Home'));
export const AuthPage = lazy(() => import('pages/Auth/Auth'));
export const JobsPage = lazy(() => import('pages/Jobs/Jobs'));
export const EditJobPage = lazy(() => import('pages/EditJobPage/EditJobPage'));
export const CreateJobPage = lazy(
  () => import('pages/CreateJobPage/CreateJobPage')
);
export const JobseekersPage = lazy(() => import('pages/Jobseekers/Jobseekers'));
export const ApplicationsPage = lazy(
  () => import('pages/Applications/Applications')
);
export const RecruitmentOverviewReportPage = lazy(
  () => import('pages/RecruitmentOverviewReport/RecruitmentOverviewReport')
);
export const EmploymentConfirmation = lazy(
  () =>
    import(
      'pages/NotificationPages/EmploymentConfirmation/EmploymentConfirmation'
    )
);
export const AccessPendingPage = lazy(
  () => import('pages/AccessPending/AccessPending')
);
